import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue'
import type Loading from './loading.vue'

export const loadingProps = buildProps({})

export type LoadingProps = ExtractPropTypes<typeof loadingProps>
export type LoadingInstance = InstanceType<typeof Loading>
